import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import Gallery from "./pages/gallery/Gallery";
import Contact from "./pages/contact/Contact";
import Blog from "./pages/blog/Blog";
import DirectorMessage from "./pages/about/DirectorMessage";
import AboutUs from "./pages/about/AboutUs";
import PrincipalsMessage from "./pages/about/PrincipalsMessage";
import VisionAndMission from "./pages/about/VisionAndMission";
import Facility from "./pages/facility/Facility";
import Admission from "./pages/admission/Admission";
import TopResult from "./pages/result/TopResult";
import Activities from "./pages/activities/Activities";
import DetailsBlog from "./pages/blog/DetailsBlog";
import Faculty from "./pages/faculty/Faculty";
import OurVideo from "./pages/gallery/OurVideo";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/director-message" element={<DirectorMessage />} />
            <Route path="/principal-message" element={<PrincipalsMessage />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/faculty" element={<Faculty />} />
            <Route path="/top-result" element={<TopResult />} />
            <Route path="/facility" element={<Facility />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/our-video" element={<OurVideo />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/details-blog" element={<DetailsBlog />} />
            <Route path="/contact-us" element={<Contact />} />

          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
